import {ReactNode} from "react";
import {DibJsonNode} from "../../types";
import {buildTopicUrl} from "../../contentUtils";
import {ExperimentalLink} from "../../../../components/ExperimentalLink";
import contentLinkClasses from "../contentLink.module.css";

export const AutoLinkNav = ({
    node,
    children,
}: {
    node: DibJsonNode;
    children: ReactNode[];
}) => {
    if (!node.object || node.object.type !== "linkdata") {
        return <span>{children}</span>;
    }

    const {topicTypeId, topicName, topicId, segmentId} = node.object.data;
    const href = buildTopicUrl(topicTypeId, topicName, topicId, segmentId);

    return (
        <ExperimentalLink href={href} className={contentLinkClasses.navLink}>
            {children}
        </ExperimentalLink>
    );
};
